var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.conversationId)?_c('a',{staticClass:"button is-small offer-conversation-btn",attrs:{"title":"צפה בשיחה שהתקיימה עם המועמד על ההצעה"},on:{"click":_vm.openChatbotPanel}},[_vm._v("\n  שיחה\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }